<script setup>
import { useDevice, useCalculateScrollProgress, computed } from '#imports';

const { isMobile } = useDevice();

const props = defineProps({
  bottomOffset: {
    type: Number,
    default: 0,
  },
});

const { progress } = useCalculateScrollProgress({
  bottomOffset: props.bottomOffset,
});

const indicatorWidth = computed(() => {
  const width = progress.value >= 100 ? '100%' : `${progress.value}%`;
  return { width };
});
</script>

<template>
  <ClientOnly>
    <template v-if="isMobile">
      <Transition name="fade">
        <div v-if="progress <= 102" class="progress-bar-mobile">
          <div
            class="progress-bar-mobile__indicator pride"
            :style="indicatorWidth"
          ></div>
        </div>
      </Transition>
    </template>
  </ClientOnly>
</template>

<style lang="postcss" scoped>
.progress-bar-mobile {
  display: none;

  @media (--small-vp) {
    position: relative;
    z-index: 1;
    display: block;
    width: 94%;
    margin: 0 auto;
    height: 8px;
    border-radius: 4px;
    background-color: #f0e4f0;

    &__indicator.pride {
      background: linear-gradient(
        90.36deg,
        #000 0%,
        #613915 9.29%,
        #74d7ee 17.73%,
        #ffafc8 26.17%,
        #fff 37.25%,
        #e40303 48.86%,
        #ff8c00 58.88%,
        #ffed00 68.38%,
        #004dff 78.93%,
        #750787 86.85%
      );
    }

    &__indicator {
      position: absolute;
      height: 8px;
      border-radius: 4px;
      top: 0;
      bottom: 0;
      left: 0;
      right: auto;
      background-color: var(--accent-color);
    }
  }
}
</style>
